import { useRef, useEffect } from 'react'
import { gsap } from 'gsap'
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons'
import { Icon } from '@/ui'

/**
 * Spinning loading indicator shown inside the send button while the adviser
 * is streaming a response. Mounts the GSAP rotation tween and cleans it up
 * on unmount.
 */
export const ChatThinking = () => {
  const iconRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const tween = gsap.to(iconRef.current, {
      rotation: 360,
      duration: 1,
      repeat: -1,
      ease: 'none',
    })
    return () => {
      tween.kill()
    }
  }, [])

  return (
    <span ref={iconRef} className="flex items-center justify-center">
      <Icon
        icon={faSpinnerThird}
        color="text-neutral-0"
        className="text-[12px]"
      />
    </span>
  )
}
